
import React from 'react';
import ShoppingListTile from './ShoppingListTile';

interface DateSelectorProps {
  date: Date;
  isSelected: boolean;
  hasMealPlan: boolean;
  mealPlans: Array<{ 
    type: 'recipe' | 'composition';
    id: string;
    name: string;
    recipeIds?: string[];
    isQuickRecipe?: boolean;
    mealType: string;
    imageUrl?: string;
    storageImageUrl?: string;
    userImageUrl?: string;
  }> | null;
  onToggle: (date: Date) => void;
}

const DateSelector: React.FC<DateSelectorProps> = ({
  date,
  isSelected,
  hasMealPlan,
  mealPlans,
  onToggle,
}) => {
  return (
    <ShoppingListTile
      date={date}
      isSelected={isSelected}
      hasMealPlan={hasMealPlan}
      mealPlans={mealPlans}
      onToggle={onToggle}
    />
  );
};

export default DateSelector;
